import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import * as moment from 'moment';

import { StayDao } from '../daos/stay.dao';
import { PastStay } from '../model/past-stay';
import { PastStayBuilder } from './builders/past-stay.builder';

@Injectable()
export class StayService {

  constructor(private _stayDao: StayDao) { }

  public getStaysInPeriod(): Observable<PastStay[]> {
    const d = moment();
    d.subtract(180, 'days');
    return this._stayDao.getStaysInPeriod(d.format('YYYY-MM-DDTHH:mm:ss.ssZ')).pipe(
      map((data: any) => {
        const stayList: Array<PastStay> = [];
        for (let i = 0, len = data.stays.length; i < len; i++) {
          stayList[i] = PastStayBuilder.buildStay(data.stays[i]);
        }
        return stayList;
      }),
      catchError((error) => {
        return Observable.throw(error);
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/stay.service.ts